<ion-content [fullscreen]="true" class="ion-padding sheet">
	<ion-buttons>
		<ion-button class="close-btn" (click)="close()" fill="clear">
			<ion-icon name="close"></ion-icon>
		</ion-button>
	</ion-buttons>
	<h2 class="title">
		Wie viele Personen<br />
		seid ihr?
	</h2>

	<div #scrollContainer class="scroll-container">
		<div class="pad" data-type="pad"></div>

		@for (n of numbers; track n) {
			<div class="num" [class.active]="n === current" (click)="selectNumber(n)">
				{{ n }}
			</div>
		}

		<div class="pad" data-type="pad"></div>
	</div>

	<ion-button (click)="confirmCenter()" class="confirm" expand="block">Bestätigen</ion-button>
</ion-content>
